import * as React from 'react'

function RubyIcon(props) {
    return (
        <svg width="20px" height="20px" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path d="M7.415 7.344C11.865 2.929 17.608.32 19.814 2.545c2.202 2.221-.131 7.629-4.59 12.042-4.453 4.414-10.126 7.165-12.326 4.945-2.207-2.221.056-7.769 4.514-12.184zM1.004 24.859zM26.192 1.108a5.315 5.315 0 014.782 5.988l.003-.027.019-.039-1.706 22.354-22.155 1.52A5.498 5.498 0 011.006 24.9l-.002.023 2.056-3.749 4.151 9.695 3.505-11.427-.037.009.02-.037 11.565 3.694-1.744-6.787-1.237-4.874 11.022-.711-.769-.637-7.913-6.451 4.572-2.55z" />
        </svg>
    )
}

export default RubyIcon
